import React from "react";
import logo from "../../assets/logo.svg";
import classes from "./style/Logo.module.css";
import { Link } from "react-router-dom";

export const Logo: React.FC = () => {
  return (
    <Link to="/" className={classes.logoContainer}>
      <img src={logo} alt="Logo" className={classes.logo} />
    </Link>
  );
};
